import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
app.initializers.add('justoverclock/christmas-snow-effect', () => {
  extend('flarum/forum/components/PostStream', 'view', function (vdom) {
    if (vdom.children && vdom.children.splice) {
      const insert = m("div", {
        key: "snowflakes",
        className: "snowflakes",
        "aria-hidden": "true"
      }, m("div", {
        className: "snowflake"
      }, "\u2745"), m("div", {
        className: "snowflake"
      }, "\u2745"), m("div", {
        className: "snowflake"
      }, "\u2746"), m("div", {
        className: "snowflake"
      }, "\u2744"), m("div", {
        className: "snowflake"
      }, "\u2745"), m("div", {
        className: "snowflake"
      }, "\u2746"), m("div", {
        className: "snowflake"
      }, "\u2744"), m("div", {
        className: "snowflake"
      }, "\u2745"), m("div", {
        className: "snowflake"
      }, "\u2746"), m("div", {
        className: "snowflake"
      }, "\u2744"));
      vdom.children.splice(1, 0, insert);
    }
  });
  override(IndexPage.prototype, 'hero', function (original) {
    return m('[', null, original(), m("div", {
      className: "snowflakes",
      "aria-hidden": "true"
    }, m("div", {
      className: "snowflake"
    }, "\u2745"), m("div", {
      className: "snowflake"
    }, "\u2745"), m("div", {
      className: "snowflake"
    }, "\u2746"), m("div", {
      className: "snowflake"
    }, "\u2744"), m("div", {
      className: "snowflake"
    }, "\u2745"), m("div", {
      className: "snowflake"
    }, "\u2746"), m("div", {
      className: "snowflake"
    }, "\u2744"), m("div", {
      className: "snowflake"
    }, "\u2745"), m("div", {
      className: "snowflake"
    }, "\u2746"), m("div", {
      className: "snowflake"
    }, "\u2744")));
  });
});